(function () {
  function addBusinessDays(date, count) {
    var result = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    var remaining = Number(count) || 0;
    while (remaining > 0) {
      result.setDate(result.getDate() + 1);
      var day = result.getDay();
      if (day !== 0 && day !== 6) remaining -= 1;
    }
    return result;
  }

  function formatDate(date) {
    return new Intl.DateTimeFormat(document.documentElement.lang || 'en', {
      month: 'short', day: 'numeric'
    }).format(date);
  }

  function renderDeliveryWindows(root) {
    root.querySelectorAll('[data-sc-commerce-guidance]').forEach(function (guidance) {
      var target = guidance.querySelector('[data-sc-delivery-window]');
      var minimum = Number(guidance.dataset.deliveryMin);
      var maximum = Number(guidance.dataset.deliveryMax);
      if (!target || !minimum || !maximum) return;
      var today = new Date();
      target.textContent = formatDate(addBusinessDays(today, minimum)) + '–' + formatDate(addBusinessDays(today, maximum)) + ' for ' + (guidance.dataset.country || 'your market');
    });
  }

  function collectProperties(formData) {
    var properties = {};
    formData.forEach(function (value, key) {
      var match = key.match(/^properties\[(.+)\]$/);
      if (match && value !== '') properties[match[1]] = value;
    });
    return properties;
  }

  function parseBalloonColors(value) {
    return value.split(',').map(function (entry) { return entry.trim(); }).filter(Boolean);
  }

  function validateBalloonColors(form, showError) {
    var input = form.querySelector('[data-balloon-colors]');
    if (!input) return true;

    var entries = parseBalloonColors(input.value);
    var uniqueEntries = {};
    var validEntry = /^(?:[1-9]|[1-7]\d|8[0-2])$/;
    var message = '';

    if (entries.length < 1) {
      message = 'Choose at least one balloon colour.';
    } else if (entries.length > 5) {
      message = 'Choose no more than five balloon colours.';
    } else if (entries.some(function (entry) { return !validEntry.test(entry); })) {
      message = 'Use the colour numbers from the chart, separated by commas.';
    } else if (entries.some(function (entry) {
      var key = entry.toLowerCase();
      if (uniqueEntries[key]) return true;
      uniqueEntries[key] = true;
      return false;
    })) {
      message = 'Remove duplicate balloon colours.';
    }

    var error = form.querySelector('#balloonColorsError');
    var valid = message === '';
    input.setCustomValidity(message);
    input.setAttribute('aria-invalid', !valid && showError ? 'true' : 'false');

    if (error) {
      error.textContent = showError && !valid ? message : '';
      error.hidden = !showError || valid;
    }

    return valid;
  }

  function bindBalloonColorValidation(root) {
    root.querySelectorAll('form[data-product-form]').forEach(function (form) {
      var input = form.querySelector('[data-balloon-colors]');
      if (!input || form.dataset.scBalloonColorsBound === 'true') return;
      form.dataset.scBalloonColorsBound = 'true';

      validateBalloonColors(form, false);
      input.addEventListener('input', function () { validateBalloonColors(form, input.value.trim() !== ''); });
      input.addEventListener('blur', function () { validateBalloonColors(form, true); });
      input.addEventListener('invalid', function () { validateBalloonColors(form, true); });
      form.addEventListener('change', function () {
        window.setTimeout(function () { validateBalloonColors(form, false); }, 0);
      });
      form.addEventListener('submit', function (event) {
        if (validateBalloonColors(form, true)) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        input.focus();
      }, true);
    });
  }

  function bindPumpAddons(root) {
    root.querySelectorAll('form[data-product-form]').forEach(function (form) {
      if (form.dataset.scPumpBound === 'true') return;
      var checkbox = form.querySelector('[data-sc-pump-checkbox]');
      if (!checkbox) return;
      form.dataset.scPumpBound = 'true';

      form.addEventListener('submit', function (event) {
        if (!validateBalloonColors(form, true) || !form.checkValidity()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          form.reportValidity();
          return;
        }
        if (!checkbox.checked) return;
        event.preventDefault();
        event.stopImmediatePropagation();

        var button = form.querySelector('[data-product-atc]');
        var buttonText = button && button.querySelector('.atc-button--text');
        var originalText = buttonText ? buttonText.textContent : '';
        var error = form.querySelector('[data-sc-pump-error]');
        var formData = new FormData(form);
        var variantId = Number(formData.get('id'));
        var pumpVariantId = Number(checkbox.dataset.pumpVariantId);
        var quantity = Number(formData.get('quantity')) || 1;
        var properties = collectProperties(formData);

        if (!variantId || !pumpVariantId) return;
        if (error) { error.hidden = true; error.textContent = ''; }
        if (button) button.disabled = true;
        if (buttonText) buttonText.textContent = 'Adding kit and pump…';

        var mainItem = { id: variantId, quantity: quantity };
        if (Object.keys(properties).length) mainItem.properties = properties;
        if (formData.get('selling_plan')) mainItem.selling_plan = Number(formData.get('selling_plan'));

        fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [mainItem, { id: pumpVariantId, quantity: 1 }] })
        })
          .then(function (response) {
            if (!response.ok) return response.json().then(function (payload) { throw new Error(payload.description || 'Unable to add these items.'); });
            return response.json();
          })
          .then(function () {
            window.location.assign(window.Theme && window.Theme.routes ? window.Theme.routes.cart_url : '/cart');
          })
          .catch(function (requestError) {
            if (button) button.disabled = false;
            if (buttonText) buttonText.textContent = originalText;
            if (error) {
              error.textContent = requestError.message || 'The pump could not be added. Please try again.';
              error.hidden = false;
            }
          });
      }, true);
    });
  }

  function initialize(root) {
    renderDeliveryWindows(root || document);
    bindBalloonColorValidation(root || document);
    bindPumpAddons(root || document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initialize(document); });
  } else {
    initialize(document);
  }
  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
})();
